import { configureStore } from '@reduxjs/toolkit';
import layoutReducer from '../Reducers/Layout'

export const store = configureStore({
    reducer: {
        layout: layoutReducer
    },
})